import script from "./OnboardingLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingLayout.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingLayout.vue?vue&type=style&index=0&id=2bbffad9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bbffad9"]])

export default __exports__